import { render, staticRenderFns } from "./EmailPasswordStep.vue?vue&type=template&id=b18a74f2&"
import script from "./EmailPasswordStep.vue?vue&type=script&lang=js&"
export * from "./EmailPasswordStep.vue?vue&type=script&lang=js&"
import style0 from "./EmailPasswordStep.vue?vue&type=style&index=0&id=b18a74f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports